// Lightweight public game constants for metadata and static explanatory copy.
// Heavy pack-opening logic lives in pack-engine and should only load on game routes/widgets.
export const CARDS_PER_PACK = 7;
export const PACKS_PER_BOX = 12;
export const DAILY_FREE_PACKS = 12;

export const PACK_ODDS_TABLE = [
  { slot: "Slots 1–4", detail: "Common (C)", odds: "Guaranteed" },
  { slot: "Slots 5–6", detail: "Uncommon (U)", odds: "Guaranteed" },
  { slot: "Slot 7 (hit)", detail: "R", odds: "60.8%" },
  { slot: "Slot 7 (hit)", detail: "RR", odds: "20.0%" },
  { slot: "Slot 7 (hit)", detail: "SR", odds: "10.0%" },
  { slot: "Slot 7 (hit)", detail: "SP", odds: "5.0%" },
  { slot: "Slot 7 (hit)", detail: "OSR", odds: "2.5%" },
  { slot: "Slot 7 (hit)", detail: "SSP", odds: "1.2%" },
  { slot: "Slot 7 (hit)", detail: "SSS", odds: "0.5%" },
] as const;

export const RARITY_GLOW: Record<string, string> = {
  C: "#94a3b8",
  U: "#60a5fa",
  R: "#a78bfa",
  RR: "#f472b6",
  SR: "#facc15",
  SP: "#fb923c",
  OSR: "#f59e0b",
  SSP: "#fef08a",
  SSS: "#fef3c7",
  TD: "#60a5fa",
  TSR: "#facc15",
  TSP: "#fb923c",
  PR: "#34d399",
};
